import { render, staticRenderFns } from "./PrintImportTradeIn.vue?vue&type=template&id=1394a3ae&scoped=true"
import script from "./PrintImportTradeIn.vue?vue&type=script&lang=js"
export * from "./PrintImportTradeIn.vue?vue&type=script&lang=js"
import style0 from "./PrintImportTradeIn.vue?vue&type=style&index=0&id=1394a3ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1394a3ae",
  null
  
)

export default component.exports